var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareLink = function SvgShareLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M11.353 19.489c-1.702 1.702-4.498 1.666-6.245-.081l-.745-.745c-1.747-1.747-1.783-4.543-.08-6.245L6.82 9.879l1.116 1.117-2.538 2.538c-1.102 1.102-1.078 2.911.052 4.042l.745.744c1.13 1.13 2.94 1.154 4.04.052l2.54-2.538 1.116 1.117zM12.26 4.44c1.702-1.702 4.498-1.666 6.246.081l.744.745c1.747 1.747 1.783 4.543.08 6.245l-2.537 2.539-1.117-1.117 2.538-2.538c1.102-1.102 1.078-2.911-.052-4.042l-.744-.744c-1.13-1.13-2.94-1.154-4.042-.052l-2.538 2.538-1.117-1.117z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "m9.665 15.36 5.538-5.537-1.255-1.255-5.537 5.538z"
  })));
};
export default SvgShareLink;